// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1memZ","item":"styles_item__1ax6d","active":"styles_active__3BcLJ","nav":"styles_nav__1Qtj2","inactive":"styles_inactive__1bIEX"};